import { useState } from 'react';

export default function AdminGrantCredits() {
  const [form, setForm] = useState({ user_id: '', storybook_credits: 0, tools_credits: 0 });
  const [msg, setMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const updateField = (key: string, value: string | number) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const submit = async () => {
    if (!form.user_id) {
      setMsg('user_id is required');
      return;
    }
    setSubmitting(true);
    setMsg('');
    try {
      const res = await fetch('/api/v1/admin/credits/grant', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Unable to grant credits');
      }
      setMsg('Granted!');
    } catch (error) {
      setMsg(error instanceof Error ? error.message : 'Unable to grant credits');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rounded-xl bg-white p-4 shadow-soft">
      <h3 className="mb-3 font-semibold">Grant Credits (Admin)</h3>
      <div className="grid gap-2 sm:grid-cols-3">
        <input
          placeholder="user_id (uuid)"
          className="input"
          value={form.user_id}
          onChange={(event) => updateField('user_id', event.target.value)}
        />
        <input
          placeholder="storybook credits"
          type="number"
          className="input"
          value={form.storybook_credits}
          onChange={(event) => updateField('storybook_credits', Number(event.target.value))}
        />
        <input
          placeholder="tools credits"
          type="number"
          className="input"
          value={form.tools_credits}
          onChange={(event) => updateField('tools_credits', Number(event.target.value))}
        />
      </div>
      <button
        onClick={submit}
        className="mt-3 badge bg-cocoa text-white"
        disabled={submitting}
        type="button"
      >
        {submitting ? 'Granting…' : 'Grant'}
      </button>
      {msg && <div className="mt-2 text-sm">{msg}</div>}
    </div>
  );
}
